module.exports = __webpack_public_path__ + "static/media/søppel.e222ca8d.m4a";